var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 0H8C3.85786 0 0.5 3.35786 0.5 7.5V42.5C0.5 46.6421 3.85786 50 8 50H43C47.1421 50 50.5 46.6421 50.5 42.5V7.5C50.5 3.35786 47.1421 0 43 0Z",
    fill: "url(#paint0_radial_7323_15133)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7898 31.6928L24.0795 32.387C23.2722 33.1296 22.5457 33.8804 21.7627 34.615C21.4429 34.9417 21.0371 35.1712 20.5922 35.2769H20.4954H20.3743C20.3703 35.2393 20.3703 35.2014 20.3743 35.1639C20.4469 34.171 20.5277 33.17 20.6084 32.169C20.673 31.2892 20.7456 30.4093 20.8102 29.5213C20.8102 29.2711 20.8506 29.0128 20.8748 28.7625C20.8882 28.7059 20.9193 28.655 20.9636 28.6172L24.5638 25.3237L31.8289 18.7044L32.7976 17.8164C32.8632 17.7551 32.9227 17.6875 32.9752 17.6146C33.0721 17.4774 33.0236 17.3644 32.8622 17.324C32.7784 17.298 32.6903 17.2889 32.603 17.2972C32.5157 17.3055 32.431 17.3311 32.3536 17.3725C32.2217 17.4382 32.0948 17.5137 31.9742 17.5985L18.1382 26.3005C17.8799 26.4619 17.6297 26.6314 17.331 26.7848C17.2603 26.8088 17.1837 26.8088 17.1131 26.7848L10.9135 24.9039C10.7038 24.847 10.4987 24.7741 10.3 24.686C10.2043 24.6527 10.1182 24.5964 10.0491 24.5222C9.98012 24.4479 9.93031 24.3579 9.90404 24.26C9.87778 24.1621 9.87585 24.0593 9.89844 23.9605C9.92103 23.8617 9.96744 23.7699 10.0336 23.6931C10.1951 23.4525 10.426 23.2667 10.6956 23.1603C11.3306 22.8912 11.9683 22.6222 12.6087 22.3531L23.0543 18.3169L35.97 13.3363C36.1417 13.2682 36.3204 13.2195 36.5028 13.191C36.8134 13.1564 37.1253 13.244 37.3724 13.4354C37.6195 13.6268 37.7824 13.9068 37.8267 14.2162C37.8992 14.5622 37.8992 14.9195 37.8267 15.2656C37.2939 17.7761 36.753 20.2866 36.2122 22.8051L34.404 31.1681C34.1134 32.5404 33.8309 33.9046 33.5241 35.2688C33.4662 35.5482 33.374 35.8193 33.2496 36.076C33.2012 36.2076 33.1271 36.3282 33.0317 36.4309C32.9362 36.5335 32.8213 36.6162 32.6936 36.674C32.5659 36.7319 32.428 36.7637 32.2878 36.7678C32.1477 36.7718 32.0082 36.748 31.8773 36.6976C31.5401 36.6097 31.2225 36.4591 30.941 36.2536C28.9229 34.7441 26.9048 33.2427 24.8625 31.7331L24.7898 31.6928Z",
    fill: "url(#paint1_linear_7323_15133)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7323_15133",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5555 -21.2141) scale(58.1288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FCEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58B7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#48A7D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#3F9ECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C9BCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7323_15133",
    x1: 23.8857,
    y1: 36.7783,
    x2: 23.8857,
    y2: 13.2152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F2FAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.ba53e7bf8dcdd3621abc1cab3291dc09.svg";
export { ForwardRef as ReactComponent };